<template>
  <div class="schedule-item-group">
    <div class="columns">
      <div class="schedule-lab-column column is-2">
        {{ group.name }}
      </div>
      <div class="column">
        <div :key="student.id" v-for="student in group.items">
          <ScheduleItem :item="student" />
          <div
            v-if="session.count > 35 && student.index === 27"
            class="separator"
          >
            <hr />
            <div class="legend">15 min break</div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleItem from "@/components/schedule/ScheduleItem.vue";
export default {
  components: {
    ScheduleItem
  },
  props: ["group", "session"]
};
</script>

<style>
.separator {
  width: 100%;
}
.separator .legend {
  width: 100%;
  text-align: center;
  color: #999;
  text-transform: uppercase;
  font-size: 11px;
}
.schedule-item-group .columns .schedule-lab-column {
  font-weight: bold;
}
</style>
